import {
  multi,
  OTHER,
  option,
  single,
  text,
  type UsOption,
  type UsWorksheetDefinition,
} from "../us-fields";

const sided = (value: string, label: string): UsOption =>
  option(value, label, { sided: true });

export const US_TESTICULAR: UsWorksheetDefinition = {
  examType: "us_testicular",
  version: 1,
  indications: [
    option("testicular_pain", "Testicular pain"),
    option("scrotal_swelling", "Scrotal swelling"),
    option("scrotal_trauma", "Scrotal trauma"),
    option("scrotal_mass", "Scrotal mass"),
  ],
  otherIndication: true,
  sections: [
    {
      id: "testicular_side",
      label: "",
      role: "findings",
      technicallyLimited: true,
      repeatPerSide: ["right", "left"],
      fields: [
        multi("testicular.scrotum", "Scrotum", [
          option("normal", "Normal"),
          option("hydrocele", "Hydrocele", {
            reveals: [
              single(
                "testicular.hydrocele_size",
                "Size",
                [
                  option("small", "Small"),
                  option("moderate", "Moderate"),
                  option("large", "Large"),
                ],
                { heading: "Hydrocele size/classification" },
              ),
              single("testicular.hydrocele_classification", "Classification", [
                option("simple", "Simple"),
                option("complex", "Complex"),
              ]),
            ],
          }),
          option("bowel_present", "Bowel present"),
          option("varicocele", "Varicocele"),
          OTHER,
        ]),
        single(
          "testicular.echogenicity",
          "Echogenicity",
          [
            option("homogeneous", "Homogeneous"),
            option("heterogeneous", "Heterogeneous"),
          ],
          { normal: "homogeneous", heading: "Testicle" },
        ),
        single(
          "testicular.flow",
          "Flow",
          [
            option("normal", "Normal"),
            option("decreased", "Decreased"),
            option("absent", "Absent"),
            option("increased", "Increased"),
          ],
          { normal: "normal" },
        ),
        single(
          "testicular.mass",
          "Mass",
          [option("absent", "Absent"), option("present", "Present"), OTHER],
          { normal: "absent" },
        ),
        single(
          "testicular.epididymis",
          "Epididymis",
          [
            option("normal", "Normal"),
            option("flow_increased", "Flow increased"),
            option("cyst", "cyst"),
          ],
          { normal: "normal" },
        ),
        text("testicular.other_findings", "Other scrotal findings"),
      ],
    },
    {
      id: "testicular_impression",
      label: "Impression",
      role: "impression",
      fields: [
        multi("testicular.impression", "Impression", [
          option("normal_scrotal", "Normal focused scrotal ultrasound"),
          sided("testicular_torsion", "testicular torsion"),
          sided("epididymitis", "Epididymitis"),
          sided("orchitis", "Orchitis"),
          sided("inguinal_hernia", "inguinal hernia"),
          sided("hydrocele", "Hydrocele"),
          sided("mass", "Mass"),
          sided("varicocele", "Varicocele"),
          sided("indeterminate", "indeterminate"),
          OTHER,
        ]),
      ],
    },
  ],
  normalImpressions: [
    { sectionId: "testicular_impression", value: "normal_scrotal" },
  ],
  billing: {
    codes: [
      {
        cpt: "76870",
        label: "Ultrasound of scrotum and contents",
        preTick: true,
      },
    ],
  },
};
